// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2pR2Z","title":"AfterFrontImage_title__3XBMP"};